// PDF export using browser print + styled HTML

export function exportReportPDF({ title, period, totalIncome, totalExpense, transactions, categories }) {
  const fmt = (v) => new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(v);
  const fmtDate = (d) => new Date(d + 'T12:00:00').toLocaleDateString('pt-BR');
  const savings = totalIncome - totalExpense;
  const catsMap = Object.fromEntries(categories.map(c => [c.id, c]));

  const rows = transactions.map(tx => `
    <tr>
      <td>${fmtDate(tx.date)}</td>
      <td>${tx.description}</td>
      <td>${catsMap[tx.categoryId]?.name || tx.categoryId}</td>
      <td style="color:${tx.type==='income'?'#1d9e75':'#e24b4a'};text-align:right;font-weight:600">
        ${tx.type==='income'?'+':'-'}${fmt(tx.value)}
      </td>
      <td style="text-align:center"><span style="background:${tx.status==='paid'?'#EAF3DE':'#FAEEDA'};color:${tx.status==='paid'?'#3B6D11':'#854F0B'};padding:2px 8px;border-radius:20px;font-size:11px">${tx.status==='paid'?'Pago':'Pendente'}</span></td>
    </tr>
  `).join('');

  const html = `<!DOCTYPE html><html lang="pt-BR"><head><meta charset="UTF-8">
  <title>MAW Finanças — Relatório</title>
  <style>
    body{font-family:Inter,Arial,sans-serif;color:#1a1a2e;padding:32px;max-width:900px;margin:0 auto}
    .header{display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;padding-bottom:16px;border-bottom:2px solid #c9a227}
    .logo{font-size:24px;font-weight:800;letter-spacing:2px;color:#0d1b2a}
    .logo span{color:#c9a227}
    h2{font-size:18px;color:#1a1a2e;margin:0 0 4px}
    .period{font-size:13px;color:#6b7280}
    .metrics{display:grid;grid-template-columns:repeat(3,1fr);gap:16px;margin-bottom:28px}
    .metric{background:#f8f9fa;border-radius:10px;padding:16px;text-align:center}
    .metric-label{font-size:12px;color:#6b7280;margin-bottom:6px}
    .metric-value{font-size:22px;font-weight:700}
    table{width:100%;border-collapse:collapse;font-size:13px}
    th{background:#0d1b2a;color:#fff;padding:10px 12px;text-align:left;font-weight:500}
    td{padding:9px 12px;border-bottom:1px solid #f0f0f0}
    tr:hover td{background:#f9f9f9}
    .footer{margin-top:28px;text-align:center;font-size:11px;color:#9ca3af;border-top:1px solid #e5e7eb;padding-top:16px}
    @media print{body{padding:0}.no-print{display:none}}
  </style></head><body>
  <div class="header">
    <div>
      <div class="logo">MAW <span>FINANÇAS</span></div>
      <h2>${title}</h2>
      <div class="period">Período: ${period}</div>
    </div>
    <div>
      <button class="no-print" onclick="window.print()" style="background:#c9a227;color:#0d1b2a;border:none;padding:10px 20px;border-radius:8px;font-size:14px;font-weight:600;cursor:pointer">🖨️ Imprimir</button>
    </div>
  </div>
  <div class="metrics">
    <div class="metric"><div class="metric-label">Total Receitas</div><div class="metric-value" style="color:#1d9e75">${fmt(totalIncome)}</div></div>
    <div class="metric"><div class="metric-label">Total Despesas</div><div class="metric-value" style="color:#e24b4a">${fmt(totalExpense)}</div></div>
    <div class="metric"><div class="metric-label">Saldo do Período</div><div class="metric-value" style="color:${savings>=0?'#1d9e75':'#e24b4a'}">${fmt(savings)}</div></div>
  </div>
  <table>
    <thead><tr><th>Data</th><th>Descrição</th><th>Categoria</th><th style="text-align:right">Valor</th><th style="text-align:center">Status</th></tr></thead>
    <tbody>${rows}</tbody>
  </table>
  <div class="footer">Gerado por MAW Finanças · ${new Date().toLocaleDateString('pt-BR', {day:'2-digit',month:'long',year:'numeric'})} · ${transactions.length} transações</div>
  </body></html>`;

  const win = window.open('', '_blank');
  win.document.write(html);
  win.document.close();
  setTimeout(() => win.print(), 500);
}

export function exportCSV(transactions, categories) {
  const catsMap = Object.fromEntries(categories.map(c => [c.id, c]));
  const fmt = (v) => v.toFixed(2).replace('.', ',');
  const rows = [
    ['Data', 'Descrição', 'Tipo', 'Categoria', 'Valor', 'Status'],
    ...transactions.map(tx => [
      tx.date, tx.description,
      tx.type === 'income' ? 'Receita' : 'Despesa',
      catsMap[tx.categoryId]?.name || tx.categoryId,
      fmt(tx.value),
      tx.status === 'paid' ? 'Pago' : 'Pendente',
    ])
  ];
  const csv = rows.map(r => r.map(c => `"${c}"`).join(';')).join('\n');
  const blob = new Blob(['﻿' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a'); a.href = url; a.download = `maw-financas-${new Date().toISOString().slice(0,10)}.csv`; a.click();
  URL.revokeObjectURL(url);
}
